import {EntityType} from "../@core/entityType";
import {Operation} from "reactcoregk";

export const entityType = EntityType.Job;
export const entityOperations = [
  Operation.getAll,
];
